export enum SnomedConceptTypeEnum {
  Procedure = 1,
  RegimeTherapy = 2,
  ObservableEntity = 3,
  Finding = 4,
  Disorder = 5,
  Situation = 6,
  BodyStructure = 7,
  RecordArtifact = 8,
  Attribute = 9,
  Product = 10,
  Substance = 11,
  StagingScale = 12,
  Specimen = 13,
  Event = 14,
  PhysicalObject = 15,
  QualifierValue = 16,
  Environment = 17,
  SocialContext = 18,
  MorphologicAbnormality = 19,
  AssessmentScale = 20
}

export const SnomedConceptTypeOptions = [
{ id: 1, label: 'Procedure' },
{ id: 2, label: 'Regime/Therapy' },
{ id: 3, label: 'Observable Entity' },
{ id: 4, label: 'Finding' },
{ id: 5, label: 'Disorder' },
{ id: 6, label: 'Situation' },
{ id: 7, label: 'Body Structure' },
{ id: 8, label: 'Record Artifact' },
{ id: 9, label: 'Attribute' },
{ id: 10, label: 'Product' },
{ id: 11, label: 'Substance' },
{ id: 12, label: 'Staging Scale' },
{ id: 13, label: 'Specimen' },
{ id: 14, label: 'Event' },
{ id: 15, label: 'Physical Object' },
{ id: 16, label: 'Qualifier Value' },
{ id: 17, label: 'Environment' },
{ id: 18, label: 'Social Concept' },
{ id: 19, label: 'Morphologic Abnormality' },
{ id: 20, label: 'Assessment Scale' }
];
